<template>
     <div class="owner-search">
          <PageTitle icon="fa fa-clone" main="Record" sub="Landlord" />
            <b-form v-show="mode === 'save' || mode === 'remove' || mode === 'read'" >
             <input id="owner-id" type="hidden" v-model="owner.id" />
             <b-row>
                <b-col md="5" sm="12">
                    <b-form-group 
                        label="Name:" 
                        label-for="owner-name_owner">
                        <b-form-input 
                            id="owner-name_owner" 
                            type="text" 
                            ref="searchFocus"
                            v-model="owner.name_owner" 
                            required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Name..." />
                    </b-form-group>
                </b-col>   
                <b-col md="3" sm="12">
                    <b-form-group 
                        label="ID:" 
                        label-for="owner-doc_identification_owner">    
                        <b-form-input
                            id="owner-doc_identification_owner" 
                            type="text"
                            v-model="owner.doc_identification_owner" 
                            required
                            size="sm"
                            :readonly="true"
                            placeholder="ID..." />  
                    </b-form-group>
                </b-col>
                <b-col md="1" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="owner.blocked_owner" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="owner-blocked_owner"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="owner-blocked_owner">
                                Blocked?
                            </label>
                        </div>
                    </div>
                </b-col>  
             </b-row>
            <b-card class="owner-search-card">
                    <b-tabs card >
                        <b-tab title="Complementary" active>
                        <b-form>
                             <b-row>
                                <b-col md="3" sm="12">
                                    <b-form-group 
                                        label="Nationality:" 
                                        label-for="owner-nationality_owner">
                                        <b-form-input 
                                            id="owner-nationality_owner" 
                                            type="text"
                                            v-model="owner.nationality_owner" 
                                              size="sm"
                                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                            placeholder="Nationality" />
                                    </b-form-group>
                                </b-col>
                              
                            </b-row>
                          
                        </b-form>

                    </b-tab >
                    <b-tab title="Address" >
                        <b-form>
                            <b-row>
                                 <b-col md="2" sm="12">
                                    <b-form-group 
                                    label="Eircode:" 
                                    label-for="owner-zip_code_owner">
                                    <b-form-input 
                                        id="owner-zip_code_owner" 
                                        type="text"
                                        v-model="owner.zip_code_owner" 
                                        size="sm"
                                    :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                    placeholder="Eircode" />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="12" sm="12">
                                    <b-form-group 
                                            label="Address:" 
                                            label-for="owner-adress_owner">
                                        <b-form-input id="owner-adress_owner" type="text"
                                        v-model="owner.adress_owner" 
                                          size="sm"
                                        :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        placeholder="Address..." />
                                    </b-form-group>
                                </b-col>
                            </b-row>   
                           
                        </b-form>    
                    </b-tab>
                    <b-tab title="Contact">
                        <b-form>
                            <b-row>
                                 <b-col md="5" sm="12">
                                    <b-form-group 
                                        label="E-mail:" 
                                        label-for="owner-email_owner">
                                        <b-form-input 
                                        id="owner-email" type="text"
                                        v-model="owner.email_owner" 
                                        size="sm"
                                        :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        placeholder="E-mail" />
                                    </b-form-group>
                                </b-col>
                                <b-col md="3" sm="12">
                                    <b-form-group 
                                        label="Phone number:" 
                                        label-for="owner-cellphone_owner">
                                        <b-form-input 
                                            id="owner-cellphone_owner" 
                                            type="text"
                                            v-model="owner.cellphone_owner" 
                                          size="sm"
                                        :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        placeholder="Phone number" />
                                    </b-form-group>
                                </b-col>
                            </b-row>   
                        </b-form>
                        </b-tab>
                        <b-tab title="Bank">
                         <b-row>
                              <b-button  
                            title="Add Bank" 
                            size="sm" 
                            class="mb-2 fa fa-plus" 
                            variant="dark" 
                            v-if="owner.id > 0"
                            @click="openModalBank">
                        </b-button>
                        </b-row>   
                        <b-row>
                              <transition  name="slide" type="animation" appear>       
                        <b-table 
                            class="table-responsive" 
                            hover 
                            key="slide"  
                            head-variant="light" 
                            :items="ownerbanks" 
                            :fields="fieldBank">

                        <template v-slot:cell(actions)="data">
                            <b-button 
                                title="Edit" 
                                size="sm" 
                                variant="light" 
                                @click="[loadOwnerBank(data.item),openModalBank()]" class="mr-2 mt-2">
                                <i class="fa fa-pencil"></i>
                            </b-button>
                            <b-button 
                                title="Delete" 
                                size="sm" 
                                variant="light" 
                                @click="showMsgBoxDeleteBank(data.item)" 
                                class="mr-2 mt-2">
                            <i class="fa fa-trash"></i>
                            </b-button>
                        </template>
                        </b-table>
                        </transition>  
                        </b-row>
                        
                        </b-tab>
                        <b-tab title="Property">

                                <b-row>
                              <b-button  
                            title="Add Property" 
                            size="sm" 
                            class="mb-2 fa fa-plus" 
                            variant="dark" 
                            v-if="owner.id > 0"
                            @click="[openModalImmobile(),immobile = {}]">
                        </b-button>
                        </b-row>   
                        <b-row>
                              <div class="col-sm-6">
                        <div class="form-group">
                            <input 
                                type="text" 
                                size="sm" 
                                icon="search" 
                                v-model="search_immobile" 
                            
                                v-show="mode !== 'save' && mode !== 'remove'"
                                placeholder="Search by Property Address" 
                                class="form-control">
                               
                        </div>
                            
                        </div>  
                        </b-row>
                        <b-row>
                             <b-col md="6" sm="12">
                        <b-form-group
                            label="Business Unit:"
                            label-for="business_unit_id"
                        >
                            <b-form-select
                                id="business_unit_id"
                                size="sm"
                                :options="businessunits"
                                v-model="business_unit_id"
                            />
                        </b-form-group>
                    </b-col>
                      <b-col md="6" sm="12">
                        <b-button 
                            size="sm" 
                            class="fa fa-search" 
                            title="Search"
                            @click="loadOwnerImmobiles()" 
                            variant="dark" >
                        </b-button>
                        <b-button 
                            size="sm" 
                            class=" ml-2 fa fa-eraser" 
                            title="Clear"
                            @click="eraser()" 
                            variant="dark" >
                        </b-button>
                      </b-col>
                        </b-row>
                        <b-row>

                        <b-col md="7" sm="12">    
                        <transition  name="slide" type="animation" appear>       
                        <b-table 
                            class="table-responsive" 
                            hover 
                            key="slide"  
                            head-variant="light" 
                            :per-page="perPageImmobile" 
                            :current-page="currentPageImmobile" 
                            :items="filteredListImmobile" 
                            :fields="fieldImmobile">

                        <template v-slot:cell(actions)="data">
                             <b-button 
                                title="Add Property Details" 
                                size="sm" 
                                variant="light" 
                                @click="[loadOwnerImmobile(data.item),openModalImmobileItem()]" class="mr-2 mt-2">
                                <i class="fa fa-plus"></i>
                             </b-button>
                             <b-button 
                                title="Property Details" 
                                size="sm" 
                                variant="light" 
                                @click="[loadOwnerImmobile(data.item),loadOwnerImmobileItems()]" class="mr-2 mt-2">
                                <i class="fa fa-external-link"></i>
                            </b-button>
                            <b-button 
                                title="Edit" 
                                size="sm" 
                                variant="light" 
                                @click="[loadOwnerImmobile(data.item),openModalImmobile()]" class="mr-2 mt-2">
                                <i class="fa fa-pencil"></i>
                            </b-button>
                            <b-dropdown id="dropdown-form-offset" size="sm" text="..." ref="dropdown" variant="outline-info" class="mr-2">
                             <b-button 
                                title="Location" 
                                size="sm" 
                                variant="light" 
                                @click="openLink(data.item.location_immobile)" class="mr-2 mt-2">
                                <i class="fa fa-map-marker"></i>
                            </b-button>    
                           
                            <b-button 
                                title="Delete" 
                                size="sm" 
                                variant="light" 
                                @click="showMsgBoxDeleteImmobile(data.item)" 
                                class="mr-2 mt-2">
                            <i class="fa fa-trash"></i>
                            </b-button>
                             <b-dropdown-divider></b-dropdown-divider>
                            <b-button 
                                title="Add Property Image " 
                                size="sm" 
                                variant="light" 
                                @click="[loadOwnerImmobile(data.item),openModalFileImmobile()]" class="mr-2 mt-2">
                                <i class="fa fa-plus"></i>
                             </b-button>
                             <b-button 
                                title="Open Image Gallery" 
                                size="sm" 
                                variant="light" 
                                @click="openModalCarousel('immobilefilesbyid',data.item.id)" 
                                class="mr-2 mt-2">
                                <i class="fa fa-file-image-o"></i>
                            </b-button>
                             <b-button 
                                title="Open List Image" 
                                size="sm" 
                                variant="light" 
                                @click="[loadOwnerImmobileFiles(data.item),openModalFileImmobileTable()]" 
                                class="mr-2 mt-2">
                                <i class="fa fa-list-alt"></i>
                            </b-button>
                            <b-button 
                                title="Open List Rules" 
                                size="sm" 
                                variant="light" 
                                @click="[loadOwnerImmobile(data.item),loadRules(),openModalImmobileRuleTable()]" 
                                class="mr-2 mt-2">
                                <i class="fa fa-list-alt"></i>
                            </b-button>
                             </b-dropdown>
                        </template>
                        </b-table>
                        </transition>
                          <b-pagination 
                            v-model="currentPageImmobile" 
                            :per-page="perPageImmobile"
                            pills 
                            :total-rows="rows_immobiles">
                            </b-pagination> 
                        </b-col>  
                        <b-col md="5" sm="12">
                            <transition  name="slide" type="animation" appear> 
                                <b-table 
                                     v-show="showTable"
                                    class="table-responsive" 
                                    hover 
                                    key="slide"  
                                    head-variant="light" 
                                    :items="immobileitems" 
                                    :fields="fieldImmobileItem">
                                <template v-slot:cell(actions)="data">
                                    <b-button 
                                        title="Edit" 
                                        size="sm" 
                                        variant="light" 
                                        @click="[loadOwnerImmobileItem(data.item),openModalImmobileItem()]" class="mr-2 mt-2">
                                        <i class="fa fa-pencil"></i>
                                    </b-button>
                                 <b-dropdown id="dropdown-form-offset" size="sm" text="..." ref="dropdown" variant="outline-info" class="mr-2 mt-2">
                               
                                        <b-button 
                                            title="Delete" 
                                            size="sm" 
                                            variant="light" 
                                            @click="showMsgBoxDeleteImmobileItem(data.item)" 
                                            class="mr-2 mt-2">
                                        <i class="fa fa-trash"></i>
                                        </b-button>
                                    <b-button 
                                        title="Add Location Image " 
                                        size="sm" 
                                        variant="light" 
                                        @click="[loadOwnerImmobileItem(data.item),openModalFileImmobileItem()]" class="mr-2 mt-2">
                                        <i class="fa fa-plus"></i>
                                    </b-button>
                                    <b-button 
                                        title="Open Image Gallery" 
                                        size="sm" 
                                        variant="light" 
                                        @click="openModalCarousel('immobileitemfilesbyid',data.item.id)" 
                                        class="mr-2 mt-2">
                                        <i class="fa fa-file-image-o"></i>
                                    </b-button>
                                    <b-button 
                                        title="Open List Image" 
                                        size="sm" 
                                        variant="light" 
                                        @click="[loadOwnerImmobileItemFiles(data.item),openModalFileImmobileItemTable()]" 
                                        class="mr-2 mt-2">
                                        <i class="fa fa-list-alt"></i>
                                    </b-button>
                                </b-dropdown>
                            </template>
                        </b-table>

                        </transition>
                        </b-col>
                        </b-row>
                        </b-tab>
                        <b-tab title="Contract">
                        <transition  name="slide" type="animation" appear>       
                        <b-table 
                            class="table-responsive" 
                            hover 
                            key="slide"  
                            head-variant="light" 
                            :items="ownercontracts" 
                            :fields="fieldContract">

                        <template v-slot:cell(actions)="data">
                             <b-button 
                                title="Property Details" 
                                size="sm" 
                                variant="light" 
                                @click="[loadOwnerImmobile(data.item),openModalImmobile()]" class="mr-2 mt-2">
                                <i class="fa fa-external-link"></i>
                            </b-button>
                            <b-button 
                                title="Edit" 
                                size="sm" 
                                variant="light" 
                                @click="[loadOwnerImmobile(data.item),openModalImmobile()]" class="mr-2 mt-2">
                                <i class="fa fa-pencil"></i>
                            </b-button>
                            <b-button 
                                title="Delete" 
                                size="sm" 
                                variant="light" 
                                @click="showMsgBoxDeleteImmobile(data.item)" 
                                class="mr-2 mt-2">
                            <i class="fa fa-trash"></i>
                            </b-button>
                        </template>
                        </b-table>
                        </transition>  
                        </b-tab>
                        <b-tab title="Task">
                        </b-tab>
                    </b-tabs>
                    
                </b-card>
        <br>
         </b-form>

            <hr v-show="mode === 'save'">
              <b-row>
                <b-col xs="12">
                   <b-button  
                        size="sm" 
                        variant="light" 
                        title="Add"
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button 
                        size="sm" 
                        variant="light"
                         title="Save"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                        size="sm" 
                        variant="light" 
                         title="Delete"
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                    </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="light" 
                         title="Back"
                        class="mt-2 mb-2 ml-2 fa fa-mail-reply"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                          title="Search"
                         :class="icon" 
                         @click="[loadOwners(),toggleBusy(),showTable = !showTable]" 
                         variant="light" >
                    </b-button>
                </b-col>
            </b-row>
            <br>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
                   <div class="col-sm-4">
                    <div class="form-group">
                        <input 
                            type="text" 
                            size="sm" 
                            icon="search" 
                            v-model="search" 
                           
                              v-show="mode !== 'save' && mode !== 'remove'"
                            placeholder="Search by landlord name" 
                            class="form-control">
                    </div>
                </div>  
          <transition  name="slide" type="animation" appear>       
         <b-table 
                 :busy="isBusy"  
                class="table-responsive" 
                :per-page="perPage" 
                :current-page="currentPage" 
                hover 
                 head-variant="dark" 
                v-show="showTable"
                :items="filteredList" 
                :fields="fields">
                <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
               <template v-slot:cell(actions)="data">
                 <b-button  
                        title = "View" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item, 'read')" 
                        class="mr-2 mt-2">
                        <i class="fa fa-drivers-license-o"></i>
                    </b-button>
                    <b-button  
                        title = "Edit" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                <b-dropdown id="dropdown-form-offset" size="sm" text="..." ref="dropdown" variant="outline-info" class="mr-2 mt-2">
                   
                     <b-button  
                        title = "Delete" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item, 'remove')" class="mr-2 mt-2">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </b-dropdown>
                </template>    
         </b-table> 
          </transition>
          <transition  name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
          </transition>
    </b-row>
        <b-modal
            id="modalImmobileFileTable"
            ref="modal"
            title-tag="h6"
            title="Property Image"
            hide-footer
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            >
            <b-form>
                <b-table 
                    class="table-responsive" 
                    hover 
                    key="slide"  
                    head-variant="light" 
                    :items="immobilefiles" 
                    :fields="fieldImmobileFile">

                <template v-slot:cell(actions)="data">
                    <b-button 
                        title="Delete" 
                        size="sm" 
                        variant="light" 
                        @click="showMsgBoxDeleteFileImmobile(data.item)" 
                        class="mr-2 mt-2">
                    <i class="fa fa-trash"></i>
                    </b-button>
                </template>
                </b-table>
            </b-form>
        </b-modal>
        <b-modal
            id="modalImmobileItemFileTable"
            ref="modal"
            title-tag="h6"
            title="Location Image"
            hide-footer
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            >
            <b-form>
                <b-table 
                    class="table-responsive" 
                    hover 
                    key="slide"  
                    head-variant="light" 
                    :items="immobileItemfiles" 
                    :fields="fieldImmobileItemFile">

                <template v-slot:cell(actions)="data">
                    <b-button 
                        title="Delete" 
                        size="sm" 
                        variant="light" 
                        @click="showMsgBoxDeleteFileImmobileItem(data.item)" 
                        class="mr-2 mt-2">
                    <i class="fa fa-trash"></i>
                    </b-button>
                </template>
                </b-table>
            </b-form>
        </b-modal>
     <b-modal
            id="modalImmobileRuleTable"
            ref="modal"
            title-tag="h6"
            title="Rules"
            hide-footer
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            >
            <b-form>
                <b-row>
                    <b-button 
                    title="Add Rule " 
                    size="sm" 
                    variant="light" 
                    @click="openModalImmobileRule()" class="ml-2 mt-2 mb-2">
                    <i class="fa fa-plus"></i>
                    </b-button>
                </b-row>
                <b-table 
                    class="table-responsive" 
                    hover 
                    key="slide"  
                    head-variant="light" 
                    :items="immobilerules" 
                    :fields="fieldImmobileRule">

                <template v-slot:cell(actions)="data">
                    <b-button 
                        title="Delete" 
                        size="sm" 
                        variant="light" 
                        @click="showMsgBoxDeleteRule(data.item)" 
                        class="mr-2 mt-2">
                    <i class="fa fa-trash"></i>
                    </b-button>
                </template>
                </b-table>
            </b-form>
        </b-modal>
     <b-modal
            id="modalBank"
            ref="modal"
            title-tag="h6"
            title="Bank"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveBank"
        >
            <b-form>
                <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group
                            label="Account Name:"
                            label-for="ownerbank-account_name_owner_bank"
                        >
                            <b-form-input
                                id="ownerbank-account_name_owner_bank"
                                v-model="ownerbank.account_name_owner_bank"
                                type="text"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group
                            label="Bank Name:"
                            label-for="ownerbank-bank_name_owner"
                        >
                            <b-form-input
                                id="ownerbank-bank_name_owner"
                                v-model="ownerbank.bank_name_owner"
                                type="text"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                     <b-col md="6" sm="12">
                        <b-form-group
                            label="BCI:"
                            label-for="ownerbank-bic_owner_bank"
                        >
                            <b-form-input
                                id="ownerbank-bic_owner_bank"
                                v-model="ownerbank.bic_owner_bank"
                                type="text"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="6" sm="12">
                        <b-form-group
                            label="IBAN:"
                            label-for="ownerbank-iban_owner_bank"
                        >
                            <b-form-input
                                id="ownerbank-iban_owner_bank"
                                v-model="ownerbank.iban_owner_bank"
                                type="text"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                <b-col md="1" sm="12">
                    <div class="form-group">
                    <div class="form-check">
                        <input class="form-check-input" 
                            v-model="ownerbank.favorite_owner_bank" 
                            true-value="1" false-value="0" 
                            type="checkbox" 
                            id="ownerbank-favorite_owner_bank"
                        >
                        <label 
                            class="form-check-label" 
                            for="ownerbank-favorite_owner_bank">
                            Favorite?
                        </label>
                    </div>
                    </div>
                </b-col>  
            
                </b-row>
            </b-form>
        </b-modal>
         <b-modal
            id="modalImmobile"
            ref="modal"
            title-tag="h6"
            title="Property"
            size="lg"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveImmobile"
        >
          <b-form>
                <b-row>
                      <b-col md="6" sm="12">
                        <b-form-group
                            label="Business Unit:"
                            label-for="immobile-business_unit_id_immobile"
                        >
                            <b-form-select
                                id="immobile-business_unit_id_immobile"
                                size="sm"
                                :options="businessunits"
                                v-model="immobile.business_unit_id_immobile"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="6" sm="12">
                    <b-form-group
                        label="Administrative Fee:"
                        label-for="immobile-administrative_fee_value"
                    >
                        <b-form-input
                            id="immobile-administrative_fee_value"
                            type="number"
                            v-model="immobile.administrative_fee_value"
                            size="sm"
                            step="0.02"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                        />
                    </b-form-group>
                </b-col>
                </b-row>
                <b-row>
                   <b-col md="4" sm="12">
                        <b-form-group
                            label="Region Route:"
                            label-for="immobile-region_route_id_immobile"
                        >
                            <b-form-select
                                id="immobile-region_route_id_immobile"
                                size="sm"
                                :options="regionroutes"
                                v-model="immobile.region_route_id_immobile"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="8" sm="12">
                    <b-form-group 
                            label="Address:" 
                            label-for="immobile-address_immobile">
                        <b-form-input id="immobile-address_immobile" 
                            type="text"
                            v-model="immobile.address_immobile" 
                            size="sm"
                            placeholder="Address..." />
                    </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12" sm="12">
                    <b-form-group 
                            label="Eircode:" 
                            label-for="immobile-region_immobile">
                        <b-form-input id="immobile-region_immobile" 
                            type="text"
                            v-model="immobile.region_immobile" 
                            size="sm"
                            placeholder="Eircode..." />
                    </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6" sm="12">
                        <b-form-group
                            label="Type:"
                            label-for="immobile-type_immobile_id_immobile"
                        >
                            <b-form-select
                                id="immobile-type_immobile_id_immobile"
                                size="sm"
                                :options="typeimmobiles"
                                v-model="immobile.type_immobile_id_immobile"
                            />
                        </b-form-group>
                    </b-col>
                <b-col md="4" sm="12">
                    <b-form-group
                        label="Maximum Tenant:"
                        label-for="immobile-maximum_number_tenant_immobile"
                    >
                        <b-form-input
                            id="immobile-maximum_number_tenant_immobile"
                            type="number"
                            v-model="immobile.maximum_number_tenant_immobile"
                            size="sm"
                        />
                    </b-form-group>
                </b-col>
                </b-row>
                 <b-row>
                     <b-col md="8" sm="12">
                        <b-form-group 
                                label="Url Location:" 
                                label-for="immobile-location_immobile">
                            <b-form-input id="immobile-location_immobile" 
                                type="text"
                                v-model="immobile.location_immobile" 
                                size="sm"
                                placeholder="Url Location..." />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-card bg-variant="info" text-variant="white" header="GAS">
                <b-row>
                     <b-col md="8" sm="12">
                        <b-form-group 
                                label="GPRN Gas:" 
                                label-for="immobile-name_gas_immobile">
                            <b-form-input id="immobile-name_gas_immobile" 
                                type="text"
                                v-model="immobile.name_gas_immobile" 
                                size="sm"
                                placeholder="GPRN Gas..." />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group 
                                label="Gas Card Number:" 
                                label-for="immobile-gas_contract_immobile">
                            <b-form-input id="immobile-gas_contract_immobile" 
                                type="text"
                                v-model="immobile.gas_contract_immobile" 
                                size="sm"
                                placeholder="Gas Card Number..." />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                     <b-col md="6" sm="12">
                        <b-form-group 
                                label="Login Gas:" 
                                label-for="immobile-gas_login_immobile">
                            <b-form-input id="immobile-gas_login_immobile" 
                                type="text"
                                v-model="immobile.gas_login_immobile" 
                                size="sm"
                                placeholder="Login Gas..." />
                        </b-form-group>
                    </b-col>
                    <b-col md="6" sm="12">
                        <b-form-group 
                                label="Password Gas:" 
                                label-for="immobile-gas_password_immobile">
                            <b-form-input id="immobile-gas_password_immobile" 
                                type="text"
                                v-model="immobile.gas_password_immobile" 
                                size="sm"
                                placeholder="Password Gas..." />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="8" sm="12">
                    <b-form-group 
                            label="Url Gas:" 
                            label-for="immobile-gas_url_site_immobile">
                        <b-form-input id="immobile-gas_url_site_immobile" 
                            type="text"
                            v-model="immobile.gas_url_site_immobile" 
                            size="sm"
                            placeholder="Url Electricity..." />
                    </b-form-group>
                </b-col>
                </b-row>
                </b-card>
                <br>
                <b-card bg-variant="success" text-variant="white" header="Electricity" >
                <b-row>
                    <b-col md="8" sm="12">
                        <b-form-group 
                                label="MPRN:" 
                                label-for="immobile-name_energy_immobile">
                            <b-form-input id="immobile-name_energy_immobile" 
                                type="text"
                                v-model="immobile.name_energy_immobile" 
                                size="sm"
                                placeholder="MPRN Electricity..." />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group 
                                label="Card Number:" 
                                label-for="immobile-energy_contract_immobile">
                            <b-form-input id="immobile-energy_contract_immobile" 
                                type="text"
                                v-model="immobile.energy_contract_immobile" 
                                size="sm"
                                placeholder="Electricity Card Number..." />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6" sm="12">
                        <b-form-group 
                                label="Login:" 
                                label-for="immobile-energy_login_immobile">
                            <b-form-input id="immobile-energy_login_immobile" 
                                type="text"
                                v-model="immobile.energy_login_immobile" 
                                size="sm"
                                placeholder="Login Electricity..." />
                        </b-form-group>
                    </b-col>
                     <b-col md="6" sm="12">
                        <b-form-group 
                                label="Password:" 
                                label-for="immobile-energy_password_immobile">
                            <b-form-input id="immobile-energy_password_immobile" 
                                type="text"
                                v-model="immobile.energy_password_immobile" 
                                size="sm"
                                placeholder="Password Electricity..." />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                     <b-col md="8" sm="12">
                        <b-form-group 
                                label="Url Electricity:" 
                                label-for="immobile-energy_url_site_immobile">
                            <b-form-input id="immobile-energy_url_site_immobile" 
                                type="text"
                                v-model="immobile.energy_url_site_immobile" 
                                size="sm"
                                placeholder="Url Electricity..." />
                        </b-form-group>
                    </b-col>
                </b-row>
                </b-card>
                <b-row>
                    <b-col md="2" sm="12">
                        <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="immobile.active_immobile" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="immobile-active_immobile"
                            >
                            <label 
                                class="form-check-label" 
                                for="immobile-active_immobile">
                                Active?
                            </label>
                        </div>
                        </div>
                    </b-col>  
                     <b-col md="2" sm="12">
                        <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="immobile.blocked_immobile" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="immobile-blocked_immobile"
                            >
                            <label 
                                class="form-check-label" 
                                for="immobile-blocked_immobile">
                                Blocked?
                            </label>
                        </div>
                        </div>
                    </b-col>  
                     <b-col md="4" sm="12">
                        <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="immobile.pet_allowed_immobile" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="immobile-pet_allowed_immobile"
                            >
                            <label 
                                class="form-check-label" 
                                for="immobile-pet_allowed_immobile">
                                Pets Allowed?
                            </label>
                        </div>
                        </div>
                    </b-col>  
                </b-row>
               
          </b-form>
        </b-modal>
         <b-modal
            id="modalImmobileItemSub"
            ref="modal"
            title-tag="h6"
            title="Sub Location"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveImmobileItemSub"
        >
               <b-form>
                     <b-row>
                        <b-col md="12" sm="12">
                            <b-form-group
                                label="Sub Location:"
                                label-for="immobileitemsub-type_part_immobile_sub_id_sub"
                            >
                                <b-form-select
                                    id="immobileitemsub-type_part_immobile_sub_id_sub"
                                    size="sm"
                                    :options="typepartimmobilesubs"
                                    v-model="immobileitemsub.type_part_immobile_sub_id_sub"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="6" sm="12">
                        <b-form-group 
                                label="Description:" 
                                label-for="immobileitemsub-description_item_sub">
                            <b-form-input id="immobileitemsub-description_item_sub" 
                                type="text"
                                v-model="immobileitemsub.description_item_sub" 
                                size="sm"
                                placeholder="Description..." />
                        </b-form-group>
                        </b-col>
                        <b-col md="1" sm="12">
                        <div class="form-group">
                            <div class="form-check">
                                <input class="form-check-input" 
                                    v-model="immobileitemsub.allocatable_sub" 
                                        true-value="1" false-value="0" 
                                        type="checkbox" 
                                        id="immobileitemsub-allocatable_sub"
                                    >
                                    <label class="form-check-label" for="immobileitemsub-allocatable_sub">
                                        Allocatable?
                                    </label>
                                </div>
                            </div>
                        </b-col> 
            
                </b-row>
               </b-form>
         </b-modal>
         <b-modal
            id="modalImmobileItem"
            ref="modal"
            title-tag="h6"
            title="Location"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveImmobileItem"
        >
        <b-form>
                <b-row>
                     <b-col md="6" sm="12">
                        <b-form-group
                            label="Location:"
                            label-for="immobileitem-type_part_immobile_id_item"
                        >
                            <b-form-select
                                id="immobileitem-type_part_immobile_id_item"
                                size="sm"
                                @input="loadPartImmobileSub"
                                :options="typepartimmobiles"
                                v-model="immobileitem.type_part_immobile_id_item"
                            />
                        </b-form-group>
                    </b-col>
                     <b-col md="6" sm="12">
                        <b-form-group
                            label="Sub Location:"
                            label-for="immobileitem-type_part_immobile_sub_id_item"
                        >
                            <b-form-select
                                id="immobileitem-type_part_immobile_sub_id_item"
                                size="sm"
                                :options="typepartimmobilesubs"
                                v-model="immobileitem.type_part_immobile_sub_id_item"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6" sm="12">
                        <b-form-group 
                                label="Nº Control Location:" 
                                label-for="immobileitem-number_control_item">
                            <b-form-input id="immobileitem-number_control_item" 
                                type="text"
                                v-model="immobileitem.number_control_item" 
                                size="sm"
                                placeholder="Nº Control Location..." />
                        </b-form-group>
                    </b-col>
                     <b-col md="6" sm="12">
                        <b-form-group 
                                label="Nº Control Sub Location:" 
                                label-for="immobileitem-number_control_item_sub">
                            <b-form-input id="immobileitem-number_control_item_sub" 
                                type="text"
                                v-model="immobileitem.number_control_item_sub" 
                                size="sm"
                                placeholder="Nº Control Sub Location..." />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6" sm="12">
                    <b-form-group 
                            label="Description:" 
                            label-for="immobileitem-description_item">
                        <b-form-input id="immobileitem-description_item" 
                            type="text"
                            v-model="immobileitem.description_item" 
                            size="sm"
                            placeholder="Description..." />
                    </b-form-group>
                    </b-col>
                    <b-col md="1" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="immobileitem.allocatable_item" 
                                    true-value="1" false-value="0" 
                                    type="checkbox" 
                                    id="immobileitem-allocatable_item"
                                >
                                <label class="form-check-label" for="immobileitem-allocatable_item">
                                    Allocatable?
                                </label>
                            </div>
                        </div>
                    </b-col> 
                </b-row>
                <b-row>
                     <b-col md="12" sm="12">
                         <b-form-textarea
                            id="immobileitem-comments_item"
                            v-model="immobileitem.comments_item"
                            placeholder="Comments..."
                            rows="3"
                            max-rows="6"
                            ></b-form-textarea>
                     </b-col>
                </b-row>
        </b-form>
         </b-modal>
          <b-modal
            id="modalCarouselImageOwner"
            hide-footer
            ref="modal"
            title-tag="h6"
            title="Image Gallery"
            size="lg"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <CarouselImage :objeto="objeto_local" :objeto_id="objeto_local_id" />
          </b-modal>
        <b-modal
         id="modalFileImmobile"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="File"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveImmobileFile"
      >
        <b-form>
            <b-row>
                 <b-col md="8" sm="12">
                    <b-form-group 
                        label="Description:" 
                        label-for="immobilefile-description_file">
                        <b-form-input 
                            id="immobilefile-description_file" 
                            type="text" 
                            v-model="immobilefile.description_file" 
                            size="sm"
                            placeholder="Description..." />
                    </b-form-group>
                </b-col>  
            </b-row>
          <b-row>
            <b-col md="12" sm="12">
              <b-form-file
                accept=".jpg, .png, .gif"
                v-model="file"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                @input="saveImagemImmobile"
                size="sm"
              ></b-form-file>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>    
       <b-modal
         id="modalFileImmobileItem"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="File"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveImmobileItemFile"
      >
        <b-form>
             <b-row>
                 <b-col md="8" sm="12">
                    <b-form-group 
                        label="Description:" 
                        label-for="immobileItemfile-description_file">
                        <b-form-input 
                            id="immobileItemfile-description_file" 
                            type="text" 
                            v-model="immobileItemfile.description_file" 
                            size="sm"
                            placeholder="Description..." />
                    </b-form-group>
                </b-col>  
            </b-row>
          <b-row>
            <b-col md="12" sm="12">
              <b-form-file
                accept=".jpg, .png, .gif"
                v-model="file"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                @input="saveImagemImmobileItem"
                size="sm"
              ></b-form-file>
            </b-col>
          </b-row>
        </b-form>
      </b-modal> 
      <b-modal
         id="modalImmobileRule"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="Rule"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveImmobileRule"
      >
        <b-form>
             <b-row>
                 <b-col md="8" sm="12">
                    <b-form-group 
                        label="Description:" 
                        label-for="immobilerule-description_rule">
                        <b-form-input 
                            id="immobilerule-description_rule" 
                            type="text" 
                            v-model="immobilerule.description_rule" 
                            size="sm"
                            placeholder="Description..." />
                    </b-form-group>
                </b-col>  
            </b-row>
        </b-form>
      </b-modal> 
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
import CarouselImage from '../util/CarouselImage'

var moment = require('moment-timezone')

export default {
    name: 'ownerSearch',
    components: {PageTitle,CarouselImage },
    data: function() {
        return {
                mode: 'insert',
                search: '',
                search_immobile: '',
                objeto_local: '',
                objeto_local_id: null,
                business_unit_id: null,
                file:null,
                owner: {},
                ownerbank: {},
                immobile: {},
                immobileitem: {},
                immobileitemsub: {},
                immobileItemfile:{},
                immobilefile:{},
                immobilerule:{},
                businessunits: [],
                immobilerules:[],
                immobileItemfiles:[],
                immobilefiles:[],
                ownerbanks:[],
                immobiles:[],
                immobileitems:[],
                immobileitemsubs:[],
                owners: [],
                typeimmobiles: [],
                regionroutes:[],
                typepartimmobiles: [],
                typepartimmobilesubs: [],
                ownercontracts:[],
                perPageImmobile:2,
                currentPageImmobile:1,
                perPage: 50,
                currentPage: 1,
                 isBusy: false,
                 showTable: false,
                 showTableItem: false,
                 showTableItemSub: false,
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                fields: [
                { key: 'name_owner', label: 'Name', sortable: true,variant: 'light' },
                { key: 'doc_identification_owner', label: 'ID', sortable: true ,variant: 'light'},
                { key: 'nationality_owner', label: 'Nationality', sortable: false ,variant: 'light'},   
                { key: 'email_owner', label: 'E-mail', sortable: false ,variant: 'light'},   
                { key: 'cellphone_owner', label: 'Phone number', sortable: false ,variant: 'light'},   
                { key: 'adress_owner', label: 'Address', sortable: false ,variant: 'light'},   
                { key: 'quantity_immobile', label: 'Number of Properties', sortable: false ,variant: 'light'},   
                { key: 'blocked', label: 'Blocked', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' ,variant: 'light'},    

                { key: 'actions', label: 'Action',variant: 'light' },
                //{ key: 'accesses', label: 'Acessos',variant: 'secondary' }
                ],
                fieldBank: [
                  { key: 'favorite_owner_bank', label: 'Favorite', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' },
                { key: 'account_name_owner_bank', label: 'Account Name', sortable: true },
                { key: 'bank_name_owner', label: 'Bank Name', sortable: false },
                { key: 'bic_owner_bank', label: 'BIC', sortable: false },
                { key: 'iban_owner_bank', label: 'IBAN', sortable: false },
              
                { key: 'actions', label: 'Action',variant: 'light' }
                ],
                fieldImmobile:[
                    { key: 'address_immobile', label: 'Address', sortable: true },
                    { key: 'region_immobile', label: 'Eircode', sortable: true },
                    { key: 'maximum_number_tenant_immobile', label: 'Maximum Tenant', sortable: true },
                    { key: 'quantity_allocated', label: 'Number of Tenants', sortable: true },
                    { key: 'administrative_fee_value', label: 'Admin. Fee', sortable: false  ,formatter: value => (value ? this.formatPrice(value) : 0)},
                     { key: 'active_immobile', label: 'Active', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' },
                     { key: 'pet_allowed_immobile', label: 'Pets Allowed', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' },   
                     { key: 'actions', label: 'Action',variant: 'light' }    
                
                ],
                fieldImmobileItem:[
                     { key: 'name_type_part_immobile', label: 'Location', sortable: true },
                    // { key: 'description_item', label: 'Description', sortable: false },
                     { key: 'number_control_item', label: 'Nº Location', sortable: false },
                     { key: 'name_type_part_immobile_sub', label: 'Sub Location', sortable: false },
                     { key: 'number_control_item_sub', label: 'Nº Sub Location', sortable: false },
                     { key: 'status', label: 'Status', sortable: false },
                 //    { key: 'allocatable_item', label: 'Allocatable', sortable: false,
                 //       formatter: value => value ? 'Yes' : 'No' },
                     { key: 'actions', label: 'Action',variant: 'light' }    
                ],
                fieldImmobileItemSub:[
                     { key: 'name_type_part_immobile_sub', label: 'Sub Location', sortable: true },
                     { key: 'description_item_sub', label: 'Description', sortable: false },
                     { key: 'number_control_sub', label: 'Nº Location', sortable: false },
                     { key: 'status', label: 'Status', sortable: false },
                     { key: 'allocatable_item', label: 'Allocatable', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' },
                     { key: 'actions', label: 'Action',variant: 'light' }    
                ],
                fieldImmobileFile:[
                     { key: 'description_file', label: 'Description', sortable: false },
                     { key: 'name_file', label: 'File name', sortable: false },
                     { key: 'actions', label: 'Action',variant: 'light' }    
                ],
                fieldImmobileRule:[
                     { key: 'description_rule', label: 'Rule', sortable: false },
                     { key: 'actions', label: 'Action',variant: 'light' }    
                ],
                fieldImmobileItemFile:[
                     { key: 'description_file', label: 'Description', sortable: false },
                    { key: 'name_file', label: 'File name', sortable: false },
                     { key: 'actions', label: 'Action',variant: 'light' }    
                ],
                fieldContract:[
                    {
                        key: 'date_contract',label: 'Contract Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('MM-DD-YYYY') : ''
                    },
                     { key: 'active_contract', label: 'Active', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' },
                    { key: 'additive_contract', label: 'Additive', sortable: false },
                    { key: 'address_immobile', label: 'Address', sortable: true },
                    { key: 'region_immobile', label: 'Region', sortable: false },
                    { key: 'name_type_mmobile', label: 'Type', sortable: false ,variant: 'light'},
                    { key: 'day_for_payment_contract', label: 'Payment Day', sortable: false },
                    { key: 'day_for_receive_contract', label: 'Receive Day', sortable: false },
                    { key: 'contract_month_contract', label: 'Contract Months', sortable: false,variant: 'light'},
                    {
                        key: 'closing_date_contract',label: 'Closing Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('MM-DD-YYYY') : ''
                    },
                ],
                 fieldTask: [
                 { key: 'description_task', label: 'Favorite', sortable: false},
                 {
                    key: 'start_date_task_release',label: 'Start Date',sortable: true,
                            formatter: value =>
                            value ? moment(value).format('MM-DD-YYYY') : ''
                 },
                 {
                    key: 'end_date_task_release',label: 'End Date',sortable: true,
                            formatter: value =>
                            value ? moment(value).format('MM-DD-YYYY') : ''
                },
               { key: 'start_hours_task_release', label: 'Start Hours', sortable: false},
               { key: 'end_hours_task_release', label: 'End Hours', sortable: false},
               { key: 'comments_task_release', label: 'Comments', sortable: false},
                { key: 'paralyze_task_release', label: 'Paralyze', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' },
                { key: 'finished_task_release', label: 'Finished', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' },        
                { key: 'actions', label: 'Action',variant: 'light' }
                ],
            }
        },
        computed: {
            filteredList() {
                return this.owners.filter(owner => {
                    return owner.name_owner.toLowerCase().includes(this.search.toLowerCase())
                    })
            },
            filteredListImmobile() {
                return this.immobiles.filter(immobile => {
                    return immobile.address_immobile.toLowerCase().includes(this.search_immobile.toLowerCase())
                    })
            },
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            rows() {
                return this.owners.length
            },
            rows_immobiles() {
                return this.immobiles.length
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{
             formatPrice(value) {
                        let val = (value / 1).toFixed(2).replace('.', ',')
                        return '€ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                    },
            formatDateTime(date) {
                return moment(date)
                    .format('YYYY-MM-DD LT')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            async showMsgBoxDeleteFileImmobile(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to delete the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeFileImmobile(item)
                    }
                })
            },
            async showMsgBoxDeleteFileImmobileItem(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to delete the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeFileImmobileItem(item)
                    }
                })
            },
            async showMsgBoxDeleteBank(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to delete the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeBank(item)
                    }
                })
            },
             async showMsgBoxDeleteImmobile(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to delete the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeImmobile(item)
                    }
                })
            },
             async showMsgBoxDeleteImmobileItem(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to delete the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeImmobileItem(item)
                    }
                })
            },
            async showMsgBoxDeleteRule(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to delete the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeRule(item)
                    }
                })
            },
            loadOwners(){
                const url = `${baseApiUrl}/ownersbycompany/${this.compan.id}`
                axios(url).then(res =>{
                     this.owners = res.data
                      this.isBusy = false
                })
            },
            loadOwnerBanks(){
                const url = `${baseApiUrl}/ownerbankbyowner/${this.owner.id}`
                axios(url).then(res =>{
                     this.ownerbanks = res.data
                })
            },
            loadRules(){
                const url = `${baseApiUrl}/immobilerulesbyid/${this.immobile.id}`
                axios(url).then(res =>{
                     this.immobilerules = res.data
                })
            },
            loadOwnerImmobiles(){
                const url = `${baseApiUrl}/immobilebyowner/${this.owner.id}/?business_unit_id=${this.business_unit_id}`
                axios(url).then(res =>{
                     this.immobiles = res.data
                })
            },
            loadOwnerImmobileItems(){
                this.showTableItem = true
                const url = `${baseApiUrl}/immobileitemsbyidimmobile/${this.immobile.id}`
                axios(url).then(res =>{
                     this.immobileitems = res.data
                })
            },
            loadOwnerImmobileItemSubs(){
                this.showTableItemSub = true
                const url = `${baseApiUrl}/immobileitemsubsbyidimmobile/${this.immobileitem.id}`
                axios(url).then(res =>{
                     this.immobileitemsubs = res.data
                })
            },
             loadOwnerContracts(){
                const url = `${baseApiUrl}/ownercontractsbyowner/${this.owner.id}`
                axios(url).then(res =>{
                     this.ownercontracts = res.data
                })
            },
            alterModo() {
                    this.mode = 'save'
                    this.owner = {}
                    this.ownerbank = {}
                    this.immobile = {}
                    this.immobileitem = {}
                    this.ownerbanks = []
                    this.immobiles = []
                    this.immobileitems = []
                    this.$refs.searchFocus.focus();
            },
             reset() {
                this.mode = 'insert'
                this.loadOwners()
                this.ownerbanks = []
                this.immobiles = []
                this.owner = {}
            },
            async save() {

                const method = this.owner.id ? 'put' : 'post'
                const id = this.owner.id ? `/${this.owner.id}` : ''

                if(this.owner.id){
                    this.owner.update_date_owner = this.formatDateTime(Date())
                    this.owner.update_user_id_owner = this.user.id
                }else{
                    this.owner.user_id_owner = this.user.id
                    this.owner.company_id_owner = this.compan.id
                }

                await axios[method](`${baseApiUrl}/owners${id}`, this.owner)
                    .then(async () => {
                        this.$toasted.global.defaultSuccess()
                        await this.createEntity(this.owner)
                        this.reset()
                    })
                    .catch(showError)
            },
            async createEntity(item){
                 await axios['post'](`${baseApiUrl}/ownerscreateentity`, item)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()

                    })
                    .catch(showError)
            },
            async saveBank() {

                    if (this.ownerbank.id) {
                        this.ownerbank.update_user_owner_bank = this.user.id
                        this.ownerbank.update_date_owner_bank = this.formatDateTime(Date())
                    } else {
                        this.ownerbank.user_id_owner_bank = this.user.id
                    }

                    const method = this.ownerbank.id ? 'put' : 'post'
                    const id = this.ownerbank.id ? `/${this.ownerbank.id}` : ''
                    this.ownerbank.owner_bank_id = this.owner.id
                    await axios[method](
                        `${baseApiUrl}/ownerbanks${id}`,
                        this.ownerbank
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.ownerbank = {}
                            this.loadOwnerBanks()
                        })
                        .catch(showError)
            },
            async saveImmobile() {

                    if (this.immobile.id) {
                        this.immobile.update_user_immobile = this.user.id
                        this.immobile.update_date_immobile = this.formatDateTime(Date())
                    } else {
                        this.immobile.user_id_immobile = this.user.id
                    }

                    const method = this.immobile.id ? 'put' : 'post'
                    const id = this.immobile.id ? `/${this.immobile.id}` : ''
                    this.immobile.owner_id_immobile = this.owner.id
                    await axios[method](
                        `${baseApiUrl}/immobiles${id}`,
                        this.immobile
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.immobile = {}
                            this.immobileitems = []
                            this.loadOwnerImmobiles()
                        })
                        .catch(showError)
            },
            async saveImmobileItem(){
                 if (this.immobileitem.id) {
                        this.immobileitem.update_user_id_item = this.user.id
                        this.immobileitem.update_date_item = this.formatDateTime(Date())
                    } else {
                        this.immobileitem.user_id_item = this.user.id
                    }

                    const method = this.immobileitem.id ? 'put' : 'post'
                    const id = this.immobileitem.id ? `/${this.immobileitem.id}` : ''
                    this.immobileitem.immobile_id_item = this.immobile.id
                    await axios[method](
                        `${baseApiUrl}/immobileitems${id}`,
                        this.immobileitem
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.immobileitem = {}
                            this.loadOwnerImmobileItems()
                        })
                        .catch(showError)
            },
            async saveImmobileItemSub(){
                 if (this.immobileitemsub.id) {
                        this.immobileitemsub.update_user_id_sub = this.user.id
                    } else {
                        this.immobileitemsub.user_id_sub = this.user.id
                    }

                    const method = this.immobileitemsub.id ? 'put' : 'post'
                    const id = this.immobileitemsub.id ? `/${this.immobileitemsub.id}` : ''
                    this.immobileitemsub.immobile_item_id_sub = this.immobileitem.id
                    await axios[method](
                        `${baseApiUrl}/immobileitemsubs${id}`,
                        this.immobileitemsub
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.immobileitemsub = {}
                            this.loadOwnerImmobileItemSubs()
                        })
                        .catch(showError)
            },
            remove() {
                    const id = this.owner.id
                    axios.delete(`${baseApiUrl}/owners/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.reset()
                        })
                        .catch(showError)
            },
            async removeRule(item) {
                    axios.delete(`${baseApiUrl}/immobilerules/${item.id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadRules()
                        })
                        .catch(showError)
            },
           async removeBank(item) {
                    axios.delete(`${baseApiUrl}/ownerbanks/${item.id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadOwnerBanks()
                        })
                        .catch(showError)
            },
            async removeFileImmobile(item) {
                    axios.delete(`${baseApiUrl}/immobilefiles/${item.id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadOwnerImmobileFiles(item)
                        })
                        .catch(showError)
            },
            async removeFileImmobileItem(item) {
                    axios.delete(`${baseApiUrl}/immobileitemfiles/${item.id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadOwnerImmobileItemFiles(item)
                        })
                        .catch(showError)
            },
           async removeImmobile(item) {
                    axios.delete(`${baseApiUrl}/immobiles/${item.id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadOwnerImmobiles()
                        })
                        .catch(showError)
            },
             async removeImmobileItem(item) {
                    axios.delete(`${baseApiUrl}/immobileitems/${item.id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadOwnerImmobileItems()
                        })
                        .catch(showError)
            },

            loadOwner(owner, mode = 'save') {
                this.mode = mode
                this.owner = { ...owner }
                this.$refs.searchFocus.focus();
                this.loadOwnerBanks()
                this.loadRules()
                this.loadOwnerImmobiles()
                this.loadOwnerContracts()
                this.immobileitems = []
                this.showTableItem = false
            },
            loadOwnerBank(item){
                this.ownerbank = {...item}
            },
            loadOwnerImmobile(item){
                this.immobile = {...item}
            },
            loadOwnerImmobileItem(item){
                this.immobileitem = {...item}
                this.loadPartImmobileSub()
            },
            openModalBank() {
                this.$bvModal.show('modalBank')
            },
            openModalFileImmobile(){
                this.$bvModal.show('modalFileImmobile')
            },
            openModalImmobileRule(){
                this.$bvModal.show('modalImmobileRule')
            },
            openModalImmobileRuleTable(){
                this.$bvModal.show('modalImmobileRuleTable')
            },
            openModalFileImmobileTable(){
                this.$bvModal.show('modalImmobileFileTable')
            },
            openModalFileImmobileItemTable(){
                this.$bvModal.show('modalImmobileItemFileTable')
            },
            openModalFileImmobileItem(){
                this.$bvModal.show('modalFileImmobileItem')
            },
             openModalCarousel(objeto,objeto_id) {

                this.objeto_local = objeto
                this.objeto_local_id = objeto_id

                this.$bvModal.show('modalCarouselImageOwner')
            },
            openModalImmobile() {
                this.$bvModal.show('modalImmobile')
            },
            openModalImmobileItem() {
                this.$bvModal.show('modalImmobileItem')
            },
             openModalImmobileItemSub() {
                this.loadPartImmobileSub()
                this.$bvModal.show('modalImmobileItemSub')
            },
            loadTypeImmobile() {
                const url = `${baseApiUrl}/typeimmobiles`
                axios.get(url).then(res => {
                    this.typeimmobiles = res.data.map(type => {
                        return { value: type.id, text: type.name_type_mmobile }
                    })
                })
            },
            loadPartImmobile() {
                const url = `${baseApiUrl}/typepartimmobiles`
                axios.get(url).then(res => {
                    this.typepartimmobiles = res.data.map(type => {
                        return { value: type.id, text: type.name_type_part_immobile }
                    })
                })
            },
            loadPartImmobileSub() {
                const url = `${baseApiUrl}/typepartimmobilesbytypeparts/${this.immobileitem.type_part_immobile_id_item}`
                axios.get(url).then(res => {
                    this.typepartimmobilesubs = res.data.map(type => {
                        return { value: type.id, text: type.name_type_part_immobile_sub }
                    })
                })
            },
            loadEntitys(){
                const url = `${baseApiUrl}/entitysbycompany/${this.compan.id}`
                axios(url).then(res =>{
                     this.entitys = res.data.map(type => {
                        return { value: type.id, text: type.name_entity + ' - ' + type.cnpj_cpf }
                    })
                
                })
            },
            loadOwnerImmobileFiles(item){
                const url = `${baseApiUrl}/immobilefilesbyid/${item.id}`
                axios(url).then(res =>{
                     this.immobilefiles = res.data
                     
                })
            },
            loadOwnerImmobileItemFiles(item){
                 const url = `${baseApiUrl}/immobileitemfilesbyid/${item.id}`
                axios(url).then(res =>{
                     this.immobileItemfiles = res.data
                })
            },
            async getLastStorageFileImmobile() {
                const url = `${baseApiUrl}/storagefilesbylast/?name_file=${this.file.name}`
                await axios(url).then(
                    res =>
                        (this.immobilefile = {...this.immobilefile,
                            storage_id_file: res.data.id,
                            name_file_xml: res.data.name_file,
                            path_file_xml: res.data.path_file
                        })
                )
            },
            async saveImagemImmobile() {
                let formData = new FormData();
                formData.append("file", this.file);

                await axios
                    .post(`${baseApiUrl}/storagefiles`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    })
                    .then(() => {
                    this.$toasted.global.defaultSuccess();
                    this.getLastStorageFileImmobile();
                    })
                    .catch(showError);
            },
            async saveImagemImmobileItem() {
                let formData = new FormData();
                formData.append("file", this.file);

                await axios
                    .post(`${baseApiUrl}/storagefiles`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    })
                    .then(() => {
                    this.$toasted.global.defaultSuccess();
                    this.getLastStorageFileImmobileItem();
                    })
                    .catch(showError);
            },
            async getLastStorageFileImmobileItem() {
                const url = `${baseApiUrl}/storagefilesbylast/?name_file=${this.file.name}`
                await axios(url).then(
                    res =>
                        (this.immobileItemfile = {...this.immobileItemfile,
                            storage_id_file: res.data.id,
                            name_file_xml: res.data.name_file,
                            path_file_xml: res.data.path_file
                        })
                )
            },
            async saveImmobileItemFile(){

                    const method = this.immobileItemfile.id ? 'put' : 'post'
                    const id = this.immobileItemfile.id ? `/${this.immobileItemfile.id}` : ''
                    this.immobileItemfile.immobilie_item_id_file = this.immobileitem.id
                    this.immobileItemfile.user_id_file = this.user.id
                    await axios[method](
                        `${baseApiUrl}/immobileitemfiles${id}`,
                        this.immobileItemfile
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.immobileItemfile = {}
                        })
                        .catch(showError)

            },
             async saveImmobileRule(){

                    const method = this.immobilerule.id ? 'put' : 'post'
                    const id = this.immobilerule.id ? `/${this.immobilerule.id}` : ''
                    this.immobilerule.immobile_id_rule = this.immobile.id
                    this.immobilerule.user_id_immobile_rule = this.user.id
                    await axios[method](
                        `${baseApiUrl}/immobilerules${id}`,
                        this.immobilerule
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadRules()
                            this.immobilerule = {}
                        })
                        .catch(showError)

            },
            async saveImmobileFile(){

                     const method = this.immobilefile.id ? 'put' : 'post'
                    const id = this.immobilefile.id ? `/${this.immobilefile.id}` : ''
                    this.immobilefile.immobilie_id_file = this.immobile.id
                        this.immobilefile.user_id_file = this.user.id
                    await axios[method](
                        `${baseApiUrl}/immobilefiles${id}`,
                        this.immobilefile
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.immobilefile = {}
                        })
                        .catch(showError)
            },
              loadBusinesss() {
                const url = `${baseApiUrl}/businessunitbycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.businessunits = res.data.map(type => {
                        return { value: type.id, text: type.business_unit_name }
                    })
                })
            },
            loadRegionRoutes() {
                const url = `${baseApiUrl}/regionroutebycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.regionroutes = res.data.map(type => {
                        return { value: type.id, text: type.region_route_name }
                    })
                })
            },
            eraser(){
                this.business_unit_id = null
            },
            openLink(item){
                const url = item.replace(" ","")
                window.open(url,'_blank')
            },

        },
        mounted(){
            this.loadOwners()
            this.loadTypeImmobile()
            this.loadPartImmobile()
            this.loadEntitys()
            this.loadBusinesss()
            this.loadRegionRoutes()
            this.showTable = true
            this.showTableItem = false
    
        }
}
</script>

<style>


    .owner-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .owner-search button{
        font-size: 0.75rem;
    }

     .owner-search select{
        font-size: 0.75rem;
    }

    .owner-search input{
        font-size: 0.75rem;
    }

    .owner-search-card label{
        font-size: 0.75rem;
        color: black;
   
    }


    
    #modalImmobileRule {
        font-size: 0.75rem;
    }

    #modalImmobileRule button{
        font-size: 0.75rem;
    }

     #modalImmobileRule input{
        font-size: 0.75rem;
    }

      #modalImmobileRule label{
        font-size: 0.75rem;
        color: black;
    }




    #modalBank {
        font-size: 0.75rem;
    }

    #modalBank button{
        font-size: 0.75rem;
    }

     #modalBank input{
        font-size: 0.75rem;
    }

      #modalBank label{
        font-size: 0.75rem;
        color: black;
    }

     #modalImmobile {
        font-size: 0.75rem;
    }

    #modalImmobile button{
        font-size: 0.75rem;
    }

     #modalImmobile input{
        font-size: 0.75rem;
    }

      #modalImmobile select{
        font-size: 0.75rem;
    }

      #modalImmobile label{
        font-size: 0.75rem;
        color: black;
    }


     #modalImmobileItem {
        font-size: 0.75rem;
    }

    #modalImmobileItem button{
        font-size: 0.75rem;
    }

     #modalImmobileItem input{
        font-size: 0.75rem;
    }

    #modalImmobileItem select{
        font-size: 0.75rem;
    }

    #modalImmobileItem label{
        font-size: 0.75rem;
        color: black;
    }

    #modalImmobileItem textarea{
        font-size: 0.75rem;
    }

    #modalFileImmobile {
        font-size: 0.75rem;
    }

    #modalFileImmobile button{
        font-size: 0.75rem;
    }

     #modalFileImmobile input{
        font-size: 0.75rem;
    }

      #modalFileImmobile label{
        font-size: 0.75rem;
        color: black;
    }

    
    #modalFileImmobileItem {
        font-size: 0.75rem;
    }

    #modalFileImmobileItem button{
        font-size: 0.75rem;
    }

     #modalFileImmobileItem input{
        font-size: 0.75rem;
    }

      #modalFileImmobileItem label{
        font-size: 0.75rem;
        color: black;
    }
    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
